exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3F--F6Tt5JLD865b04cVqg{display:table}._1mQXfiOOXrLtJfICHYr68V{display:table-row}._39UhQtfEYB-oztfKLjY0E6,.thu1-uvWwOa7fd5RBgUE1{display:table-cell}html[dir=ltr] .thu1-uvWwOa7fd5RBgUE1{padding-left:10px}html[dir=rtl] .thu1-uvWwOa7fd5RBgUE1{padding-right:10px}html[dir] ._2np3fNv4qxQRU5oUdqC0b4{margin-top:20px}", ""]);

// exports
exports.locals = {
	"propertyContainer": "_3F--F6Tt5JLD865b04cVqg",
	"propertyRow": "_1mQXfiOOXrLtJfICHYr68V",
	"propertyName": "_39UhQtfEYB-oztfKLjY0E6",
	"propertyValue": "thu1-uvWwOa7fd5RBgUE1",
	"okButton": "_2np3fNv4qxQRU5oUdqC0b4"
};